<template>
  <div class="elencomarcheedit">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Modifica una marca</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="nome" v-model="formData.marca.nome" type="text" :state="state.nome" placeholder="Nome della marca" /><label for="nome">Nome *</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="sitoweb" v-model="formData.marca.sitoweb" type="text" :state="state.sitoweb" placeholder="Sito web della marca" /><label for="sitoweb">Sito web</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.marca.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
        </b-col>
      </b-row>
      <b-row v-if="stato.admin">
        <b-col>
          <b-form-checkbox v-model="formData.marca.globale" :value="true" :unchecked-value="false">Rendi la marca globale</b-form-checkbox>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="updateMarca()"><font-awesome-icon icon="marker" /> Aggiorna</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'elencomarcheedit',
  data() {
    return {
      state: {
        nome: null,
        sitoweb : null,
        note: null
      },
      formData:{
        marca: {
          nome: '',
          sitoweb : '',
          note: '',
          globale: false
        }
      }
    }
  },
  created: function(){
    this.loadMarca()
  },
  methods: {
    updateMarca(){
      Vue.http.post('elenco/marche/update/'+this.$route.params.id, this.formData, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Marca aggiornata con successo!',
            type: 'success'
          })
          this.$router.push('/elenco/marche')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la modifica',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    loadMarca(){
      Vue.http.post('elenco/marche/load/'+this.$route.params.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData = response.body.data
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    }
  },
  computed: {
    ...mapGetters(['stato'])
  }
}
</script>

<style>
.elencomarcheedit #nome{
  text-indent: 85px;
}

.elencomarcheedit #sitoweb{
  text-indent: 100px;
}

.elencomarcheedit #note{
  text-indent: 60px;
  line-height: 1.8;
}
</style>